import React, { useEffect, useState } from "react";
import NavBarDark from "../components/NAVBAR/NavBarDark";
import Footer from "../components/FOOTER/Footer";
import { Helmet } from "react-helmet";
import { useLocation } from "react-router-dom";
import { fetch_event } from "../api/event";
import moment from 'moment';
import GuestList from "../components/GuestList";
import AuthRSVPManager from "../components/RSVP/AuthRSVPManager";
import { getWithExpiry } from "../utils/storage";


const RSVPManagerLoginPage = () => {
  function getQueryParam(name, search) {
    const params = new URLSearchParams(search);
    return params.get(name);
  }

  const location = useLocation();
  const event_id = getQueryParam('event_id', location.search);
  console.log('RSVPManagerLoginPage event_id', event_id);

  let to = location.state?.from?.pathname || `/pending-rsvp?event_id=${event_id}`;
  console.log('RSVPManagerLoginPage to', to);
  

  try {

    return (
      <>
        <Helmet>
          <title>
            Pending RSVP - Venco Events | All-in-one Community Management
            Software
          </title>
          <meta
            property="og:title"
            content="Sign up as a Referrer - Venco | All-in-one Community Management Software"
          />
          <meta
            name="twitter:title"
            content="Sign up as a Referrer - Venco | All-in-one Community Management Software"
          />
        </Helmet>
        <NavBarDark />
        <AuthRSVPManager 
          event_id={event_id}
          to={to}
        />

        <Footer 
          
        />
      </>
    )
  } catch (error) {
    return (
      <div></div>
    )
  }
}

export default RSVPManagerLoginPage;